"use client";

import React, { useState, useEffect, useMemo } from "react";
import { usePathname } from "next/navigation";
import { Logo } from "@/components/Logo";

interface HeaderProps {
  locale: string;
  phone: string;
  logoProps?: {
    ccn?: string;
    line1?: string;
    line2?: string;
    subtext?: string;
  };
}

export const Header = ({ locale, logoProps, phone }: HeaderProps) => {
  const pathname = usePathname();

  const isHomepage = useMemo(() => {
    if (!pathname) return true;
    const cleanPath = pathname.replace(/^\/(vi|en|cn)(\/|$)/, "/");
    return cleanPath === "/";
  }, [pathname]);

  const [isScrolledState, setIsScrolledState] = useState(false);

  useEffect(() => {
    if (!isHomepage) return;
    const handleScroll = () => {
      setIsScrolledState(window.scrollY > 20);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHomepage]);

  const isScrolled = !isHomepage || isScrolledState;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-b from-[#06191e]/85 via-[#06191e]/45 to-transparent transition-all duration-500 px-4 md:px-10">
      <div className="w-full max-w-[1440px] mx-auto flex items-center justify-center py-3 md:py-6 transition-all duration-500 relative min-h-[60px] md:min-h-[85px]">
        {/* ZenGroup Logo (Top Left) */}
        {/* <div className="absolute left-0 top-1/2 -translate-y-1/2 flex items-center">
          <a
            href="https://zengroup.com.vn/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 md:gap-3 transition-all duration-300 hover:scale-[1.03] cursor-pointer"
          >
            <img
              src="/logos/ZenGroup_Logo.svg"
              alt="ZenGroup Logo"
              className="brightness-0 invert opacity-90 h-9 sm:h-11 md:h-14 lg:h-16 w-auto object-contain"
            />
            <div className="hidden md:flex flex-col text-left select-none border-l border-white/20 pl-2.5 md:pl-3">
              <span className="font-montserrat text-[9px] md:text-[10px] lg:text-[11px] text-white/60 font-semibold tracking-[0.12em] uppercase leading-tight">
                {locale === "vi"
                  ? "Tập Đoàn"
                  : locale === "en"
                    ? "ZenGroup"
                    : "禅集团"}
              </span>
              <span className="font-montserrat text-[11px] md:text-[13px] lg:text-[14px] text-white font-bold tracking-[0.12em] uppercase leading-tight mt-0.5">
                {locale === "vi"
                  ? "Zengroup"
                  : locale === "en"
                    ? "Corporation"
                    : "集团"}
              </span>
            </div>
          </a>
        </div> */}

        <div className="flex-shrink-0 flex justify-center mx-2 sm:mx-4">
          <div
            className={`transition-all duration-500 origin-top ${
              isScrolled
                ? "scale-[0.7] sm:scale-[0.7] md:scale-[0.75] lg:scale-[0.7] translate-y-0"
                : "scale-[0.9] sm:scale-[1.1] md:scale-[1.2] lg:scale-[1.3] xl:scale-[1.4] translate-y-2.5 sm:translate-y-4 md:translate-y-5 lg:translate-y-7"
            }`}
          >
            <Logo locale={locale} {...logoProps} phone={phone} />
          </div>
        </div>
      </div>
    </header>
  );
};
